import {useContext} from 'react';
import {useExperiment as useFlipperExperiment} from '@tkww/reg-flipper-sdk';
import {EXPERIMENT_CONFIGS} from '../constants';
import MemberContext from '../contexts/MemberContext';

/**
 * Reusable hook for configuring an experiment. Requires the `name` in order to look up the EXPERIMENT_CONFIGS related
 * including the variant ids and experiment ID for the environment. By default, the bucketId and isEnabled is based on whether a member is loaded in the MemberContext
 * If new criteria are given within experimentOptions, they will override these defaults
 * @param {Object} experimentOptions - options that can be passed to the flipper SDK found here: https://github.com/tkww/reg-flipper-sdk?tab=readme-ov-file#hook-api
 * @returns {{ isLoading: boolean, isInControl: boolean}}
 */
const useExperiment = (experimentOptions = {name: ''}) => {
  const {member, isFetching: isFetchingMember} = useContext(MemberContext);
  const {experimentId, variants} = EXPERIMENT_CONFIGS[experimentOptions.name][
    process.env.ENV
  ];

  const overrideParams = new URLSearchParams(window.location.search);
  const override = overrideParams.get(`flipper_override_${experimentId}`);

  const {
    isEnabled = true,
    name,
    ...sanitizedExperimentOptions
  } = experimentOptions;

  const {
    isLoading: isDeterminingAssignment,
    variant,
    isActive,
  } = useFlipperExperiment({
    experimentId,
    bucketingId: member?.id,
    isEnabled: !!member?.id && isEnabled,
    ...sanitizedExperimentOptions,
  });

  const theVariant = override ?? variant;

  return {
    isLoading: isDeterminingAssignment || isFetchingMember,
    isInControl: !isActive || !theVariant || variants.control.id === theVariant, // an 'undefined' variant should be considered in the control
    variant: theVariant,
    isActive,
    hasOverride: !!override,
  };
};

export default useExperiment;
